import Vue from 'vue'
import router from './router'
import store from './store/index'
import App from './App.vue'
import $ from 'jquery'

import VueI18n from 'vue-i18n'
import LangStorage from './helpers/lang'

import VueCookies from 'vue-cookies'
import BaiduMap from 'vue-baidu-map'

import zh from './common/lang/zh'
import en from './common/lang/en'

import './plugins/element'


Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: LangStorage.getLang('zh'),  // 语言标识
  messages: {
    'zh': zh,
    'en': en,
  },
  silentTranslationWarn: true       // 禁用翻译警告
})

Vue.use(VueCookies)

Vue.config.productionTip = false

Vue.use(BaiduMap, {
  ak: 'YOUR_APP_KEY'
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
new Vue({
	router,
	store,
  i18n,
  watch: {
    '$i18n.locale': {
      immediate: true, // 首次加载时立即执行
      handler(newLang) {
        document.title = newLang === 'en'
          ? 'Beijing Longxun Kuangteng Technology Co., Ltd.'
          : '龙讯旷腾-人工智能加速新材料研发'
      }
    }
  },
  render: h => h(App),
}).$mount('#app')
